module.exports = __webpack_public_path__ + "assets/img/kv-b2acf8d7.jpg";